export const styles = {
  container: {
    width: '100%',
    height: '100%',
    paddingRight: '80px',
    position: 'relative',
  },
  title: {
    textAlign: 'right',
    fontFamily: 'Roboto',
    fontSize: '68px',
    fontStyle: 'italic',
    fontWeight: '600',
    lineHeight: 'normal',
    zIndex: 2,
  },
  vector: {
    position: 'absolute',
    top: 0,
    right: '-100px',
    zIndex: 1,
  },
};
